import React from 'react';

import Link from 'gatsby-link';

import isEmpty from 'lodash/isEmpty';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const Header = ({ postsCategory, postsTag, postsAuthor }) => {
  if (isEmpty(postsCategory) && isEmpty(postsAuthor) && isEmpty(postsTag)) {
    return (
      <Grid item xs={12}>
        <Typography variant="h4">Recent Posts</Typography>
      </Grid>
    );
  }

  if (!isEmpty(postsCategory) && !isEmpty(postsAuthor) && !isEmpty(postsTag)) {
    return (
      <Grid item xs={12}>
        <Link to="/blog">
          <Typography variant="h3">Back to blog</Typography>
        </Link>
      </Grid>
    );
  }

  if (!isEmpty(postsCategory)) {
    return (
      <Grid item xs={12}>
        <Typography variant="h4">
          {`Recent Posts of ${postsCategory.name}`}
        </Typography>
      </Grid>
    );
  }

  if (!isEmpty(postsTag)) {
    return (
      <Grid item xs={12}>
        <Typography variant="h4">
          {`Recent Posts of ${postsTag.name}`}
        </Typography>
      </Grid>
    );
  }

  if (!isEmpty(postsAuthor)) {
    return (
      <Grid item xs={12}>
        <Typography variant="h4">
          {`Recent Posts of ${postsAuthor.name}`}
        </Typography>
      </Grid>
    );
  }

  return null;
};

export default Header;
